<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <EmployeeWorkContractForm
      v-if="!isLoading"
      :employeeWorkContractData="employeeWorkContract"
      :submitName="$t('edit')"
      v-on:addOrUpdateEmployeeWorkContract="addOrUpdateEmployeeWorkContract()"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import EmployeeWorkContractForm from "@/components/employees/employeeWorkContracts/EmployeeWorkContractForm.vue";
import createToastMixin from "@/utils/create-toast-mixin";
import currentTabMixin from "@/utils/currentTab-mixin";
import EmployeeWorkContract from "@/models/employees/employeeWorkContracts/EmployeeWorkContract";

export default {
  name: "EmployeeWorkContractEdit",
  mixins: [createToastMixin, currentTabMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    EmployeeWorkContractForm,
  },
  computed: {
    ...mapGetters(["employeeToken"]),
  },
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      employeeWorkContract: new EmployeeWorkContract(),
    };
  },
  props: ["employeeWorkContractToken"],
  methods: {
    async getEmployeeWorkContractDetails() {
      this.isLoading = true;
      this.employeeWorkContract.employeeWorkContractToken =
        this.employeeWorkContractToken;
      try {
        let response =
          await this.employeeWorkContract.getEmployeeWorkContractDetails(
            this.language,
            this.userAuthorizeToken
          );
        if (response.data.status == STATUS.SUCCESS) {
          this.employeeWorkContract.fillData(
            response.data.employeeWorkContractsData
          );
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
          this.$router.push({ name: "EmployeeWorkContracts" }).catch(() => {});
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
        this.$router.push({ name: "EmployeeWorkContracts" }).catch(() => {});
      }
      this.isLoading = false;
    },
    async addOrUpdateEmployeeWorkContract() {
      this.isLoading = true;

      try {
        let response =
          await this.employeeWorkContract.addOrUpdateEmployeeWorkContract(
            this.language,
            this.userAuthorizeToken
          );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.$router.push({ name: "EmployeeWorkContracts" }).catch(() => {});
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.getEmployeeWorkContractDetails();
  },
};
</script>

<style scoped lang="scss"></style>
